module.exports = __webpack_public_path__ + "static/spaceKitchenDesktop_x1-289313b63c54a8b77e04290270b263c7.jpg";